import { render, staticRenderFns } from "./incidents-origins-grid.vue?vue&type=template&id=296395c5&scoped=true&"
import script from "./incidents-origins-grid.ts?vue&type=script&lang=ts&"
export * from "./incidents-origins-grid.ts?vue&type=script&lang=ts&"
import style0 from "./incidents-origins-grid.scss?vue&type=style&index=0&id=296395c5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296395c5",
  null
  
)

export default component.exports